import { AccountRow, GroupRow } from "./types";

// Required for compatibility with spreadsheet framework's Record<string, any> row type
type SpreadsheetRow = Record<string, any>;

export function isGroupRow(row: SpreadsheetRow): row is GroupRow {
    return "_isGroup" in row && row._isGroup === true;
}

export function isAccountRow(row: SpreadsheetRow): row is AccountRow {
    return "_isGroup" in row && row._isGroup === false;
}
